<template>
  <div class="flex w-full p-2 items-center">
    <router-link :to="{ name: 'product', params: { sku: product.sku } }" class="place-self-start w-1/12">
      <base-image
        :imageSource="product.cover"
      />
    </router-link>
    <div class="w-11/12 grid grid-cols-6 xl:grid-cols-12 px-3 space-x-4">
      <div class="col-span-4 xl:col-span-10"
      :class="classes">
        <div class="flex space-x-5">
          <a v-if="headerContent"
            :class="layout.header.value === 'ETICHETTA' || layout.header.value === 'AUTORE'
            ? 'font-normal text-base hover:text-lh_red dark:hover:text-lh_gold text-left'
            : 'font-normal text-base cursor-default text-left'"
            :href="`/products?filter=${this.layout.header.value}&value='${this.headerContent}'`"
          >
            {{ headerContent }}
          </a>
          <router-link :to="{ name: 'product', params: { sku: product.sku } }" class="w-full">
            <p class="font-normal text-base hover:text-lh_red dark:hover:text-lh_gold">
              {{ bodyContent }}
            </p>
          </router-link>
        </div>
        <div class="flex w-full flex-wrap">
          <div v-for="detail in layout.footerDetails" :key="detail">
            <a
              v-if="detail.value === 'ETICHETTA' || detail.value === 'AUTORE'"
              class="font-thin text-sm mr-3 hover:text-lh_red dark:hover:text-lh_gold"
              :href="`/products?filter=${detail.value}&value='${this.footerDetailContent(detail)}'`"
            >
              {{ footerDetailContent(detail) }}
          </a>
            <p
              v-else
              class="font-thin text-sm mr-3"
            >
              {{ footerDetailContent(detail) }}
            </p>
          </div>
          <p class="font-thin text-sm"
          v-if="product.NUMERO_SUPPORTI">
            {{ productSupport }} x {{ product.NUMERO_SUPPORTI }}
          </p>
        </div>
        <order-alert v-show="isAlreadyOrdered" :orderedQty="orderedQuantity"  />
      </div>
      <div class="col-span-1 justify-around space-y-2">
        <p
        v-if="product.isUnderCampaign"
        class="text-sm font-medium">
          {{ $n((product.campaignPrice / 100), 'currency') }}
      </p>
      <p
        v-else
        class="text-sm font-medium">
        {{ $n((product.price / 100), 'currency') }}
      </p>
        <!--<div class="w-full flex space-x-2">
          <div class="w-4 h-4 rounded place-self-center" :class="availabilityColors"></div>
          <p class="text-sm leading-none" v-if="showAvailableQuantity">
              {{ quantityAvailable }}
          </p>
        </div>-->
      </div>
      <div class="col-span-1 justify-around space-y-2">
        <inc-dec
          :appOptions="{
            min: product.minOrderQtyLimit,
            max: product.maxOrderQtyLimit
          }"
          v-model="qty"
          component-width="w-16"
          :class="hideCart"
        />
        <ShoppingBagIcon
          @click="addToCart()"
          class="cursor-pointer hover:text-lh_red dark:hover:text-lh_gold w-5 h-5"
          :class="hideCart"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from 'vue-toastification';
import { mapGetters, mapActions } from 'vuex';
import { addProductToCart } from '@/utils/product-service';
import IncDec from '@/components/base/IncDec.vue';
import 'vue3-carousel/dist/carousel.css';
import BaseImage from '@/components/base/BaseImage.vue';
import dayjs from 'dayjs';
import OrderAlert from '@/components/base/OrderAlert.vue';
import { ShoppingBagIcon } from '@heroicons/vue/24/outline';

export default {
  setup() {
    const toast = useToast();

    return { toast };
  },
  components: {
    IncDec,
    BaseImage,
    OrderAlert,
    ShoppingBagIcon,
  },
  data() {
    return {
      currentVariant: 0,
      directionClass: {
        landscape: 'flex flex-row',
        portrait: 'flex flex-col',
      },
      dimensionClass: {
        full: 'w-full',
        quarter: 'w-full sm:w-1/3 lg:w-1/4',
      },
      qty: this.product.minOrderQtyLimit,
      isAlreadyOrdered: false,
      orderedQuantity: 0,
    };
  },
  props: {
    direction: {
      type: String,
      default: 'portrait',
    },
    width: {
      type: String,
      default: 'full',
    },
    elementsColor: {
      type: String,
      default: 'text-black dark:text-white',
    },
    productDescription: {
      type: String,
    },
    product: {
      type: Object,
    },
    hasVariants: {
      type: Boolean,
    },
    footerDirection: {
      type: String,
      default: 'horizontal',
    },
  },
  computed: {
    ...mapGetters({
      layouts: 'layouts/layouts',
    }),
    layout() {
      if (this.layouts[this.product.productCategorySlug]) {
        return this.layouts[this.product.productCategorySlug].CardProductHorizontal;
      }
      return this.layouts.default.CardProductHorizontal;
    },
    classes() {
      return `${this.directionClass[this.direction]} ${this.elementsColor}`;
    },
    headerContent() {
      if (this.layout.header.type === 'attribute') {
        return this.product.attributes[this.layout.header.value]
          ? this.product.attributes[this.layout.header.value].value
          : '';
      }

      return this.product[this.layout.header.value];
    },
    bodyContent() {
      if (this.layout.body.type === 'attribute') {
        return this.product.attributes[this.layout.body.value]
          ? this.product.attributes[this.layout.body.value].value
          : '';
      }

      if (this.product.translations?.[this.layout.body.value]?.[this.$i18n.locale]) {
        return this.product.translations[this.layout.body.value][this.$i18n.locale];
      }

      return this.product[this.layout.body.value];
    },
    inTwoDays() {
      return dayjs().add(2, 'day').format('YYYY-MM-DD');
    },
    availabilityColors() {
      if (this.product.availableForOrders && this.product.outOfStock) {
        return 'bg-red-600';
      }
      return 'bg-green-600';
    },
    hideCart() {
      return this.product.isDiscontinued && this.product.outOfStock ? 'hidden' : 'flex';
    },
    today() {
      return dayjs(new Date()).format('YYYY-MM-DD');
    },
    discontinuedStock() {
      return !this.product.isDiscontinued && !this.product.outOfStock;
    },
    outOfStockOrder() {
      return this.product.outOfStock && !this.product.isDiscontinued;
    },
    availabilityJustForPreorder() {
      return this.product.availableForPreorders && !this.product.availableForOrders && this.outOfStockOrder;
    },
    showAvailableQuantity() {
      return this.product.availableForOrders
      && !this.product.outOfStock
      && this.product.availableFrom <= this.inTwoDays;
    },
    currentStateOrder() {
      if (this.outOfStockOrder) {
        return this.$t('frontoffice.products.outOfStock');
      }
      if (this.product.isDiscontinued) {
        return `${this.$t('frontoffice.products.isDiscontinued')}${this.showAvailableQuantity ? ':' : ''}`;
      }
      if (this.availabilityJustForPreorder) {
        return `${this.$t('frontoffice.products.upcoming')}:`;
      }
      return `${this.$t('frontoffice.products.available')}:`;
    },
    quantityAvailable() {
      if (this.product.available > 50) {
        return 50;
      }
      if (this.product.available >= 0) {
        return this.product.available;
      }
      return 0;
    },
    productSupport() {
      return this.product.SUPPORTO ? this.product.SUPPORTO : this.product.productSubcategoryName;
    },
  },
  watch: {
    product: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.qty = this.product.minOrderQtyLimit;
          this.isAlreadyOrdered = false;
          this.orderedQuantity = 0;
          this.checkOnOrderQuantity();
        }
      },
    },
  },
  created() {
    this.checkOnOrderQuantity();
  },
  methods: {
    ...mapActions({
      alreadyOrdered: 'customers/alreadyOrdered',
    }),
    attributeValues(product) {
      return product.attributes.map((av) => (av.attributeValue)).join('-');
    },
    addToCart() {
      addProductToCart(this.product, this.qty);
      this.toast.info(this.$t('frontoffice.cart.messages.productAddedToCart'));
      this.qty = 1;
    },
    footerDetailContent(detail) {
      return detail.type === 'attribute' && this.product.attributes.lenght > 0
        ? this.product.attributes[detail.value].value
        : this.product[detail.value];
    },
    async checkOnOrderQuantity() {
      const isOrdered = await this.alreadyOrdered(this.product.sku);

      if (isOrdered.found) {
        this.isAlreadyOrdered = true;
        this.orderedQuantity = isOrdered.quantity;
      }
    },
  },
};
</script>
